// generated by genversion
export var version = '4.5.1';
//# sourceMappingURL=version.js.map